<template>
  <div class="snail_aprilfoolsday_layout" @scroll="handleScroll">
    <!-- 活动标题 -->
    <div v-wechat-title="'最强蜗牛'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      name="fade"
    >
      <div
        @touchmove.prevent
        class="preloading preloading-snail"
        v-show="count < 100"
      >
        <div class="boss1"></div>
        <!-- <div class="boss" v-show="count >= 50"></div> -->
        <div class="loading_bg">
          <div class="loading">
            <div class="loading_line"></div>
          </div>
          <div class="loading_text" />
          <div class="change_text">{{ count }}%</div>
        </div>
      </div>
    </transition>
    <!-- 登录弹窗 -->
    <Login
      v-if="isShowLogin"
      @loginSuccess="loginSuccess"
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
      channelTips="角色UID可在游戏中—设置—UID查看"
      :autoOpenOS="false"
      noAuthLogin
    ></Login>

    <div v-show="count >= 100">
      <!-- 首页 -->
      <div class="index" v-show="showPage == 1">
        <div class="top">
          <div class="accountInfo" v-if="userInfo.account">
            {{ userInfo.account }}
          </div>
          <div
            class="login"
            v-if="!userInfo.account"
            @click="changeLoginPopup(true)"
          ></div>
          <div class="logout" v-else @click="confirmLogout"></div>
        </div>
        <div class="title"></div>
        <div :class="isSmallScreen ? 'card1' : 'card'">
          <div class="photo">
            <img :src="picture" alt="" />
            <div class="refresh" @click="changePhoto"></div>
          </div>
          <div class="professional_bg">{{ professional }}</div>
          <div class="name">
            <input
              type="text"
              v-model="name"
              maxlength="7"
              @focusout="inputFocusOut"
            />
          </div>
          <div class="department">
            {{ department }}
          </div>
        </div>
        <div class="sidebar">
          <div class="award" @click="showAward">
            <div class="red" v-if="isShowRed != 0"></div>
          </div>
          <div class="rules" @click="openRule"></div>
          <div class="log" @click="showLog"></div>
        </div>
        <div class="btn">
          <!-- <div class="confirm" v-if="false">
            <div class="s_tip"></div>
          </div> -->
          <div class="write_daily" @click="startGame"></div>
          <div class="company_daily" @click="approvalDaily"></div>
        </div>
      </div>
      <!-- 写日报 -->
      <div class="daily" v-if="showPage == 2">
        <div class="top"></div>
        <div class="question_bg">
          <div class="title">{{ userInfo.game_department }}</div>
          <div class="question1">{{ conversation1 }}</div>
          <div class="question2">{{ conversation2 }}</div>
          <div class="question3">{{ conversation3 }}</div>
        </div>
        <div class="answer_bg">
          <div class="answer_title">请描述你今天的工作成果</div>
          <div class="content_bg">
            <textarea
              v-if="currentProblem == 1"
              rows="5"
              cols="20"
              style="resize: none"
              :maxlength="100"
              placeholder="点击输入..."
              v-model="questionText"
            ></textarea>
            <p>{{ currentLength }}/100</p>
            <textarea
              v-if="currentProblem == 2"
              rows="5"
              cols="20"
              style="resize: none"
              :maxlength="100"
              placeholder="点击输入..."
              v-model="questionText1"
            ></textarea>
            <p v-show="currentProblem == 2">{{ currentLength1 }}/100</p>
          </div>
        </div>
        <div class="award_bg">
          <div
            class="progress50"
            v-if="problemsNum == 2 && currentProblem == 1"
          ></div>
          <div
            class="progress100"
            v-if="problemsNum == 1 || currentProblem == 2"
          ></div>
        </div>
        <div class="btn_wrap">
          <div
            class="up"
            v-if="problemsNum == 2 && currentProblem == 2"
            @click="upProblem"
          ></div>
          <div
            class="next"
            v-if="problemsNum == 2 && currentProblem == 1"
            @click="nextProblem"
          ></div>
          <div
            class="submit"
            v-if="(problemsNum == 2 && currentProblem == 2) || problemsNum == 1"
            @click="submitContextCountFun"
          ></div>
        </div>
        <div class="bottom">
          <div class="myDaily"></div>
          <div class="companyDaily" @click="changeListType(2)"></div>
        </div>
      </div>
      <!-- 分析 没有这页了-->
      <!-- <div class="excessive" v-if="showPage == 3">
        <div class="top"></div>
        <div class="result_bg" ref="excessiveRef">
          <div class="type">
            <div class="type_name">敏捷的实习策划</div>
            <div class="explain">
              那很好啊毕竟我从只是世纪来的只是只结构超越了这个时代上百年，教给学生正好！了这个时代上百年，教给学生正好！了这个时代上百年，教给学生正好！
            </div>
          </div>
          <div class="detail_bg">
            <div class="detail_item" v-for="i in 5" :key="i">
              <div class="detail_title">我是标题</div>
              <p>
                那很好啊毕竟我从只是世纪来的只是只只是只
                结构超越了这个时代上百年，教给！那很好啊
                毕竟我从只是世纪来的只是只只是只结构超越
                了这个时代上百年，教给！
              </p>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="btn" @click="showPage = 4"></div>
        </div>
      </div> -->
      <!-- 海报详情 -->
      <div class="placard" v-show="showPage == 4">
        <div class="top_bg">
          <div :class="'role role' + roleNum"></div>
          <div class="subhead">
            <div class="occupation" v-if="hasEvaluateResule">
              {{ analysisAIDetail.occupation }}
            </div>
            <!-- <div class="occupationLoading" v-if="!hasEvaluateResule"></div> -->
            <div class="saying" v-if="hasEvaluateResule">
              {{ analysisAIDetail.saying }}
            </div>
            <div class="sayingLoading" v-if="!hasEvaluateResule"></div>
          </div>
          <div class="social">
            <span v-if="hasEvaluateResule">{{ analysisAIDetail.value }}</span>
          </div>
          <div class="socialLoading" v-if="!hasEvaluateResule"></div>
          <div class="surpass_bg">
            <div class="surpass" v-if="hasEvaluateResule">
              {{ Math.floor(analysisAIDetail.surpass) }}%
            </div>
            <!-- <div class="surpassLoading" v-if="!hasEvaluateResule"></div> -->
          </div>
          <div class="radar">
            <div class="six-dimensions" id="six-dimensions"></div>
          </div>
        </div>
        <div class="top">
          <div class="goback" @click="goNewPosition"></div>
          <div class="history" @click="showLog"></div>
        </div>
        <div class="peculiarity_bg">
          <div class="peculiarity_wrap">
            <div
              v-for="(item, index) in analysisAIDetail.trait"
              :key="index"
              :class="itemClass(item, index)"
              @click="showTip(item, index)"
            >
              <div class="name">{{ item.trait_name }}</div>
              <div v-if="activeIndex === index" class="tooltip">
                {{ item.desc }}
              </div>
            </div>
          </div>
        </div>
        <div class="appraise_bg">
          <div
            class="assessment"
            v-html="analysisAIDetail.evaluate_results"
            v-if="hasEvaluateResule"
          ></div>
          <div class="assessmentLoading" v-if="!hasEvaluateResule"></div>
        </div>
        <div class="code_bg">
          <div class="code"></div>
        </div>
        <div class="bottom">
          <div class="again" @click="goNewPosition"></div>
          <div class="share" @click="generateShareImage"></div>
        </div>
      </div>
      <!-- 日报列表 -->
      <div class="list" v-show="showPage == 5">
        <div class="top">
          <div class="title">
            {{ listType == 1 ? "我的日报" : "公司日报" }}
          </div>
          <div class="goback" @click="showPage = 1"></div>
          <div class="refresh" @click="getListFun(1)"></div>
        </div>
        <div class="announcement">
          <transition-group name="slide-fade" tag="div">
            <div class="announcement-item" :key="announcementsIndex">
              {{ announcements[announcementsIndex] }}
            </div>
          </transition-group>
        </div>
        <div
          v-for="item in rankList"
          :key="item.id"
          class="list_item"
          @click="gotoLogDetail(item, 2)"
        >
          <div class="info">
            <div :class="avatarClassFun(item)"></div>
            <div class="name">
              {{ item.game_name }}
            </div>
            <div class="time">
              {{ item.game_department }}-{{ item.game_rank }}&nbsp;&nbsp;{{
                item.created_at.split(" ")[0]
              }}
            </div>
          </div>
          <div class="content">
            {{ item.log_content.achievement }}
          </div>
          <div class="like_bg" v-if="item.like_name.length > 0">
            {{ extractName(item.like_name) }}
          </div>
          <div class="my" v-if="item.is_self"></div>
          <div class="good" v-if="item.is_admin_like != 0"></div>
          <div class="like_wrap">
            <div
              :class="item.like_status ? 'like' : 'unlike'"
              @click.stop="likeApiFun(item, 1)"
            >
              <div
                class="top200"
                v-if="item.is_top == 1 && listType == 1"
              ></div>
              <div class="num">{{ item.like_num }}</div>
            </div>
            <div class="comment">
              <div class="num">{{ item.comment_count }}</div>
            </div>
          </div>
        </div>
        <div class="no_more">
          {{ totalPage > pageNo ? "加载更多..." : "暂无更多内容" }}
        </div>
        <div
          class="winner"
          v-if="activity.is_admin_like != 0"
          @click="areaDialogShow = true"
        ></div>
        <div :class="listType == 1 ? 'bottom1' : 'bottom'">
          <div class="isMy" @click="changeListType(1)"></div>
          <div class="allBtn" @click="changeListType(2)"></div>
        </div>
      </div>
      <!-- 日报详情 -->
      <div class="detail" v-if="showPage == 6">
        <div class="top">
          <div class="goback" @click="gobackList"></div>
          <div class="title">
            {{ logDetailData.current_list.game_name }}的日报
          </div>
        </div>
        <div class="info">
          <div class="time">
            {{ logDetailData.current_list.created_at.split(" ")[0] }}
          </div>
          <div class="name">{{ logDetailData.current_list.game_name }}</div>
          <div class="department">
            {{ logDetailData.current_list.game_department }}
          </div>
        </div>
        <div :class="avatarClassFun(logDetailData.current_list)"></div>
        <div class="content_bg">
          <div class="content">
            {{ logDetailData.current_list.log_content.achievement }} <br />
            {{ logDetailData.current_list.log_content.problem }}
          </div>
          <div class="like_wrap">
            <div
              :class="
                logDetailData.current_list.like_status ? 'like' : 'unlike'
              "
              @click="likeApiFun(logDetailData.current_list, 2)"
            >
              <div class="num">{{ logDetailData.current_list.like_num }}</div>
            </div>
            <div class="comment">
              <div class="num">
                {{ logDetailData.current_list.comment_count }}
              </div>
            </div>
          </div>
        </div>
        <div class="btn" v-if="logDetailData.prev || logDetailData.next">
          <div
            class="up"
            v-if="logDetailData.prev"
            @click="
              gotoLogDetail({ id: logDetailData.prev, individual_analysis: 1 })
            "
          ></div>
          <div
            class="next"
            v-if="logDetailData.next"
            @click="
              gotoLogDetail({ id: logDetailData.next, individual_analysis: 1 })
            "
          ></div>
        </div>
        <div
          class="comment_bg"
          v-if="
            logDetailData.current_list.comment_count > 0 ||
            messageLists.length > 0
          "
        >
          <div class="title">
            评论（{{ logDetailData.current_list.comment_count }}）
          </div>
          <div class="comment_list" @scroll="commentScroll">
            <div
              v-for="(item, index) in messageLists"
              :key="item.id"
              class="comment_item"
            >
              <div :class="avatarClassFun(item.user_info[0])"></div>
              <div class="name">{{ item.user_info[0].game_name }}</div>
              <div class="department">
                {{ item.user_info[0].game_department }}-{{
                  item.user_info[0].game_rank
                }}
                &nbsp;{{ item.created_at }}
              </div>
              <div class="content">
                {{ item.content }}
              </div>
              <div class="line" v-if="index != messageLists.length - 1"></div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <input
            type="text"
            placeholder="发表评论"
            class="comment_content"
            maxlength="50"
            v-model="commentContent"
          />
          <div class="send" @click="sendComment"></div>
        </div>
      </div>
      <!-- <div class="foot-page">
        <Footer :gameName="gameName" />
      </div> -->
    </div>

    <!-- 分享弹窗 -->
    <div
      class="share_wrap popup_wrap"
      :style="{
        opacity: shareShow ? '1' : '0',
        'z-index': shareShow ? '999' : '-1',
      }"
    >
      <div
        class="popup_wrap"
        style="z-index: 1; background: transparent"
        @click="shareShow = false"
      ></div>
      <div class="detail_box">
        <img :src="shareImg" alt="分享图片" />
      </div>

      <div class="text" />
    </div>

    <div
      class="share_wrap popup_wrap"
      :style="{
        opacity: shareShow ? '0' : '0',
        'z-index': shareShow ? '-1' : '-1',
      }"
    >
      <div class="share_bg" ref="imageDom">
        <div class="placard_share">
          <div class="top_bg">
            <div :class="'role role' + roleNum"></div>
            <div class="subhead">
              <div class="occupation" v-if="hasEvaluateResule">
                {{ analysisAIDetail.occupation }}
              </div>
              <!-- <div class="occupationLoading" v-if="!hasEvaluateResule"></div> -->
              <div class="saying" v-if="hasEvaluateResule">
                {{ analysisAIDetail.saying }}
              </div>
              <div class="sayingLoading" v-if="!hasEvaluateResule"></div>
            </div>
            <div class="social">
              <span v-if="hasEvaluateResule">{{ analysisAIDetail.value }}</span>
            </div>
            <div class="socialLoading" v-if="!hasEvaluateResule">
              {{ analysisAIDetail.value }}
            </div>
            <div class="surpass_bg">
              <div class="surpass" v-if="hasEvaluateResule">
                {{ Math.floor(analysisAIDetail.surpass) }}%
              </div>
              <!-- <div class="surpassLoading" v-if="!hasEvaluateResule"></div> -->
            </div>
            <div class="radar">
              <div class="six-dimensions" id="six-dimensions1"></div>
            </div>
          </div>
          <div class="peculiarity_bg">
            <div class="peculiarity_wrap">
              <div
                v-for="(item, index) in analysisAIDetail.trait"
                :key="index"
                :class="itemClass(item, index)"
                @click="showTip(item, index)"
              >
                <div class="name">{{ item.trait_name }}</div>
              </div>
            </div>
          </div>
          <div class="appraise_bg">
            <div
              class="assessment"
              v-html="analysisAIDetail.evaluate_results"
              v-if="hasEvaluateResule"
            ></div>
            <div class="assessmentLoading" v-if="!hasEvaluateResule"></div>
          </div>
          <div class="code_bg">
            <div class="code"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <!-- 规则弹窗 -->
    <div class="dialog popup_wrap" v-if="rulesDialogShow">
      <div
        class="popup_wrap"
        style="z-index: 1; background: transparent"
        @click="rulesDialogShow = false"
      ></div>
      <div class="rules"></div>
    </div>
    <!-- 奖励弹窗-无奖励 -->
    <div class="dialog popup_wrap" v-if="noAwardShow">
      <div
        class="popup_wrap"
        style="z-index: 1; background: transparent"
        @click="noAwardShow = false"
      ></div>
      <div class="no_award">
        <div
          class="btn"
          @click="
            noAwardShow = false;
            showPage = 2;
          "
        ></div>
      </div>
    </div>
    <!-- 奖励弹窗-有奖励(有实物) -->
    <div class="dialog popup_wrap" v-if="awardDialogShow">
      <div
        class="popup_wrap"
        style="z-index: 1; background: transparent"
        @click="awardDialogShow = false"
      ></div>
      <div class="award_dialog">
        <div class="cdk">{{ cdk }}</div>
        <div
          class="copyCdk"
          @click="onCopy('.copyCdk')"
          :data-clipboard-text="cdk"
        ></div>
        <div
          :class="!activity.user_phone ? 'btn' : 'btn1'"
          @click="
            awardDialogShow = false;
            areaDialogShow = true;
          "
        ></div>
      </div>
    </div>
    <!-- 奖励弹窗-有奖励(无实物) -->
    <div class="dialog popup_wrap" v-if="awardDialogShow1">
      <div
        class="popup_wrap"
        style="z-index: 1; background: transparent"
        @click="awardDialogShow1 = false"
      ></div>
      <div class="award_dialog1">
        <div class="cdk">{{ cdk }}</div>
        <div
          class="copyCdk"
          @click="onCopy('.copyCdk')"
          :data-clipboard-text="cdk"
        ></div>
        <div class="btn" @click="awardDialogShow1 = false"></div>
      </div>
    </div>
    <!-- 收货地址弹窗 -->
    <div class="dialog popup_wrap" v-if="areaDialogShow">
      <div
        class="popup_wrap"
        style="z-index: 1; background: transparent"
        @click="areaDialogShow = false"
      ></div>
      <div class="area_dialog">
        <input
          type="text"
          placeholder="请填写姓名"
          class="area_name"
          v-model="areaName"
        />
        <input
          type="text"
          placeholder="请填写手机号"
          class="area_phone"
          v-model="areaPhone"
        />
        <input
          type="text"
          placeholder="请填写地址"
          class="area"
          v-model="area"
        />
        <textarea
          rows="3"
          cols="20"
          style="resize: none"
          :maxlength="100"
          placeholder="请输入详细地址"
          v-model="address"
          @input="checkLength"
        ></textarea>
        <div class="btn" @click="addressApiFun"></div>
      </div>
    </div>
    <!-- 是否登录弹窗 -->
    <div class="dialog popup_wrap" v-if="loginDialogShow">
      <div
        class="popup_wrap"
        style="z-index: 1; background: transparent"
        @click="loginDialogShow = false"
      ></div>
      <div class="login_dialog">
        <div class="btn_wrap">
          <div class="login_btn" @click="accountLogin"></div>
          <div class="nologin" @click="againNoLogin"></div>
        </div>
      </div>
    </div>
    <!-- 第1次提交报告弹窗 -->
    <div class="dialog popup_wrap" v-if="dialogShow1">
      <!-- <div
        class="popup_wrap"
        style="z-index: 1; background: transparent"
        @click="dialogShow1 = false"
      ></div> -->
      <div class="dialog_1">
        <div class="cdk">{{ cdk }}</div>
        <div
          class="copyCdk"
          @click="onCopy('.copyCdk')"
          :data-clipboard-text="cdk"
        ></div>
        <div class="btn" @click="dialog1Submit"></div>
      </div>
    </div>
    <!-- 第2次提交报告弹窗 -->
    <div class="dialog popup_wrap" v-if="dialogShow2">
      <!-- <div
        class="popup_wrap"
        style="z-index: 1; background: transparent"
        @click="dialogShow2 = false"
      ></div> -->
      <div class="dialog_2">
        <div class="btn_wrap">
          <div class="btn" @click="submitContextFun"></div>
          <div class="download" @click="goDownload"></div>
        </div>
      </div>
    </div>
    <!-- 第3次提交报告弹窗 -->
    <div class="dialog popup_wrap" v-if="dialogShow3">
      <div
        class="popup_wrap"
        style="z-index: 1; background: transparent"
        @click="submitContextFun"
      ></div>
      <div class="dialog_3">
        <img
          src="../../../../assets/images/active/snail/aprilfoolsday/dialog/dialog_3.png"
          alt=""
        />
      </div>
    </div>
    <!-- 第4次提交报告弹窗 -->
    <div class="dialog popup_wrap" v-if="dialogShow4">
      <div
        class="popup_wrap"
        style="z-index: 1; background: transparent"
        @click="submitContextFun"
      ></div>
      <div class="dialog_4">
        <img
          src="../../../../assets/images/active/snail/aprilfoolsday/dialog/dialog_4.png"
          alt=""
        />
      </div>
    </div>
    <!-- 第5次提交报告弹窗 -->
    <div class="dialog popup_wrap" v-if="dialogShow5">
      <!-- <div
        class="popup_wrap"
        style="z-index: 1; background: transparent"
        @click="dialogShow5 = false"
      ></div> -->
      <div class="dialog_5">
        <div class="btn" @click="submitContextFun"></div>
      </div>
    </div>
    <!-- 第66次提交报告弹窗 -->
    <div class="dialog popup_wrap" v-if="dialogShow66">
      <!-- <div
        class="popup_wrap"
        style="z-index: 1; background: transparent"
        @click="dialogShow66 = false"
      ></div> -->
      <div class="dialog_66">
        <div class="btn" @click="submitContextFun"></div>
      </div>
    </div>
    <!-- 日报记录弹窗 -->
    <div class="dialog popup_wrap" v-if="logShow">
      <div
        class="popup_wrap"
        style="z-index: 1; background: transparent"
        @click="logShow = false"
      ></div>
      <div class="log">
        <div class="content" @scroll="logScroll">
          <div
            v-for="(item, index) in this.logLists"
            :key="index"
            class="log_item"
            @click="goPoster(item)"
          >
            <div :class="avatarClassFun(item)"></div>
            <div class="time">
              {{ item.created_at ? item.created_at.split(" ")[0] : "" }}
            </div>
            <div class="name">{{ item.game_name }}</div>
            <div class="department">{{ item.game_department }}</div>
            <div
              :class="!item.individual_analysis ? 'result2' : 'result1'"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 日无报记录弹窗 -->
    <div class="dialog popup_wrap" v-if="noLogShow">
      <div
        class="popup_wrap"
        style="z-index: 1; background: transparent"
        @click="noLogShow = false"
      ></div>
      <div class="log_none">
        <div
          class="btn"
          @click="
            noLogShow = false;
            showPage = 2;
          "
        ></div>
      </div>
    </div>
    <!-- 帧动画弹窗 -->
    <div class="dialog popup_wrap" v-if="aniShow">
      <div class="animation-container">
        <img id="animation" :src="aniSrc" alt="动画帧" />
      </div>
    </div>
    <!-- 是否进入分析结果页弹窗 -->
    <div class="dialog popup_wrap" v-if="isShowResult">
      <div class="result_bg">
        <div class="big_boss">
          <div class="appoint">任命{{ userInfo.game_name }}为</div>
          <div class="salutation">{{ salutation }}</div>
        </div>
        <div class="btn" @click="checkResult"></div>
        <div class="tips">{{ skipCount }}秒后自动跳转日报分析详情页</div>
      </div>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
import { Toast } from "mint-ui";
import { mapState, mapMutations, mapActions } from "vuex";
import Footer from "@/components/Footer";
import Login from "@/components/login";
import {
  onGetInitDataAPI,
  setAccountInfo,
  submitContext,
  getList,
  likeApi,
  logList,
  logDetail,
  leaveWord,
  messageList,
  awardRed,
  addressApi,
  analysisAI,
  experienceInit,
  evaluateAI,
} from "../api";
import { LogoutAPI } from "@/api/login";
import { getRandomString, buriedLogger, wechatBrowser } from "@/utils/utils";
import Clipboard from "clipboard";
import { generateQRCode, generateCanvasImage } from "@/utils/share";
import { Indicator } from "mint-ui";

export default {
  name: "order",
  components: {
    Login,
    Footer,
  },
  data() {
    return {
      gameName: "snail",
      loginTypes: ["sms", "password"],
      preventShow: false,
      logger: null,
      isWechatBrowser: false, // 是否为微信浏览器
      shareShow: false,
      shareImg: null,
      isPC: false,
      shareLink: "",
      count: 20,
      isWechatApp: false,
      picture:
        "https://download4.qcplay.com/qcgame-api/yrs1kSa75jBgCnBX2i18sU1F7obxoAd2ctKUOC2l.png", // 头像图片地址
      homePhoto: [
        {
          url: "https://download4.qcplay.com/qcgame-api/yrs1kSa75jBgCnBX2i18sU1F7obxoAd2ctKUOC2l.png",
        },
        {
          url: "https://download4.qcplay.com/qcgame-api/nJZwEZjeQTVajOngLHXQJQHg5tkPByYArFcggZAf.png",
        },
        {
          url: "https://download4.qcplay.com/qcgame-api/Z9l4GO5ouccE2RqOIt4VAoQVgCRQ2DzrjsMx2bSm.png",
        },
      ], // 头像图片地址
      photoIndex: 0, // 头像索引
      professional: "实习生", // 职称
      name: "实习生", // 花名
      department: "人力资源部", // 部门
      showPage: 1, // 当前展示页面
      questionText: "", // 问题文本
      questionText1: "", // 问题文本
      activeIndex: null,
      hideTimeout: null,
      rulesDialogShow: false, // 规则弹窗
      noAwardShow: false, // 无奖励弹窗
      awardDialogShow: false, // 有实物奖励弹窗
      awardDialogShow1: false, // 无实物奖励弹窗
      cdk: "",
      areaDialogShow: false, // 收货地址弹窗
      areaName: "", // 收货人
      areaPhone: "", // 收货电话
      area: "", // 收货地址
      loginDialogShow: false, // 是否登录弹窗
      dialogShow1: false, // 第一次提交报告
      dialogShow2: false, // 第二次提交报告
      dialogShow3: false, // 第三次提交报告
      dialogShow4: false, // 第四次提交报告
      dialogShow5: false, // 第五次提交报告
      dialogShow66: false, // 第66次提交报告
      logShow: false, // 日报弹窗
      noLogShow: false, // 无日报弹窗
      activity: {}, // 活动信息
      userInfo: {}, // 用户信息
      isShowRed: 0, // 是否显示红点
      isExperience: "0", // 是否未登录已经体验过
      log_id: "", // 日报id
      commentContent: "", // 评论内容
      isComment: false, // 新发送评论
      rankList: [], // 所有人日报列表
      listType: 2, // 日报列表类型 1是自己  2是列表
      logLists: [], // 个人日报列表
      logDetailData: {}, // 日报详情
      messageLists: [], // 评论列表
      dailyType: 1, // 日报类型 1是自己  2是列表
      problemsNum: 1, // 问题数量
      currentProblem: 1, // 当前所在的问题
      conversation1: "去帮我倒一杯咖啡。", // 对话1
      conversation2: "好的，老大。我的实习任务是什么", // 对话2
      conversation3: "除了倒咖啡你还能干啥？", // 对话3
      pageNo: 1, // 日报列表页数
      totalPage: 1, // 日报列表总页数
      isLoading: false, // 日报列表加载中
      messagePageNo: 1, // 评论列表页数
      messageTotalPage: 1, // 评论列表总页数
      isMessageLoading: false, // 评论列表加载中
      logPageNo: 1, // 个人日报列表页数
      logTotalPage: 1, // 个人日报列表总页数
      isLogLoading: false, // 个人日报列表加载中
      totalFrames: 242, // 总帧数
      currentFrame: 1, // 当前帧数
      imageArray: [], // 帧动画图片数组
      playing: false, // 是否播放中
      animationId: null, // 动画id
      lastFrameTime: 0, // 上一帧时间
      frameInterval: 42, // 帧动画间隔
      aniShow: false, // 动画弹窗
      isShowResult: false, // 是否进入分析结果页
      downloadUrl: "https://snail.qingcigame.com/official/index_mobile.html",
      salutation: "", // 分析结果称号
      skipCount: 5, // 跳过秒数
      skipTimer: null, // 跳过计时器
      roleNum: 1, // 显示第几个角色
      analysisAITimer: null, // 分析AI计时器（六维图）
      evaluateAITimer: null, // 分析AI计时器（其余结果）
      analysisAIDetail: {}, // 分析AI详情
      isSmallScreen: false, // 是否是小屏手机
      announcements: [
        "点赞最多的员工日报将设计为《最强蜗牛》绿贵",
        "被沙雕之神点赞的员工将获得神秘宅急送",
        "点赞量最高Top200将获得神秘宅急送",
      ],
      announcementsIndex: 0, // 公告索引
      announcementsTimer: null, // 公告计时器
      antiShake: false, // 防抖
      hasEvaluateResule: false, // 是否已经有分析结果
    };
  },
  created() {
    this.roleNum = Math.floor(Math.random() * 37) + 1;
    this.preloadImages();
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    this.incrementTo100();
    this.checkDevice();
    if (window.localStorage.getItem("uuid")) {
      this.getUserInfo();
    } else {
      this.experienceInitFun();
    }
    this.isExperience = window.localStorage.getItem("isExperience");

    this.isWechatBrowser = wechatBrowser();
    if (this.isWechatBrowser) {
      // 在微信app下
      this.isWechatApp = true;
    } else {
      // safari下底部被遮住
      if (
        /Safari/.test(navigator.userAgent) &&
        !/Chrome/.test(navigator.userAgent)
      ) {
      }
    }

    // 埋点
    const bl = buriedLogger("snail", "最强蜗牛愚人节活动");
    this.logger = bl;
    var userAgent = navigator.userAgent.toLowerCase();
    this.isPC =
      userAgent.indexOf("windows") > -1 || userAgent.indexOf("macintosh") > -1;
    if (this.isPC) {
      // this.$router.push(`pc${getRandomString()}`);
    } else {
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isSetShare();
    });
  },
  beforeDestroy() {
    clearInterval(this.announcementsTimer); // 清除定时器
  },
  computed: {
    currentLength() {
      return this.questionText.length;
    },
    currentLength1() {
      return this.questionText1.length;
    },
    aniSrc() {
      return this.imageArray[this.currentFrame].src || "";
    },
    ...mapState(["isShowLogin"]),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (oldValue.account) {
          if (newValue.account !== oldValue.account) {
            if (!newValue.account) {
              // TAG: 注销的时候
            } else {
              console.log("登录成功");
              this.getUserInfo();
            }
          }
        }
      },
    },
    showPage(newValue, oldValue) {
      if (newValue == 5) {
        this.startAutoScroll();
      } else {
        if (this.announcementsTimer) {
          clearInterval(this.announcementsTimer);
        }
      }
    },
  },
  methods: {
    // 检查小屏手机
    checkDevice() {
      const screenWidth = window.innerWidth;
      const isIOSDevice = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      this.isSmallScreen = isIOSDevice && screenWidth < 375; // iOS设备且宽度小于375px
    },
    // 去下载
    goDownload() {
      window.location.href = this.downloadUrl;
    },
    // 公告自动滚动
    startAutoScroll() {
      this.announcementsTimer = setInterval(() => {
        this.announcementsIndex =
          (this.announcementsIndex + 1) % this.announcements.length;
      }, 3000); // 3秒轮播一次
    },
    // 预加载帧动画图片
    preloadImages() {
      const imgPrefix =
        "https://download4.qcplay.com/snail/aprilfoolsday/ani%28";
      const imgPostfix = "%29.png";
      for (let i = 1; i <= this.totalFrames; i++) {
        const img = new Image();
        img.src = `${imgPrefix}${i}${imgPostfix}`; // 保持四位数格式
        this.imageArray.push(img);
      }
    },
    pauseAnimation30() {
      let timer = null;
      timer = setTimeout(() => {
        this.currentFrame = 29;
        this.startAnimation();
        clearTimeout(timer);
      }, 2500);
    },
    // 更新帧动画
    updateFrame(timestamp) {
      if (!this.playing) return;
      if (this.currentFrame == 28) {
        this.pauseAnimation();
        this.pauseAnimation30();
        return;
      }
      // if (this.currentFrame == 200 && !this.analysisAIDetail.trait) {
      //   return this.pauseAnimation();
      // }
      // if (this.currentFrame < this.totalFrames) {
      //   this.currentFrame++;
      // }
      if (timestamp - this.lastFrameTime >= this.frameInterval) {
        this.currentFrame++;
        this.lastFrameTime = timestamp;
      }
      if (this.currentFrame >= this.totalFrames) {
        this.currentFrame = 242; // 循环播放
        this.playing = false;
        this.isShowResult = true;
        this.aniShow = false;
        this.skipToResult();
        this.getUserInfo();
      }
      requestAnimationFrame(this.updateFrame);
    },
    // 开始动画
    startAnimation() {
      if (!this.playing) {
        this.playing = true;
        this.lastFrameTime = performance.now();
        this.updateFrame();
      }
    },
    // 暂停动画
    pauseAnimation() {
      this.playing = false;
    },
    // 点击查看分析结果
    checkResult() {
      this.logger.sum("最强蜗牛_愚人节_查看分析结果");
      this.isShowResult = false;
      this.showPage = 4;
      this.currentFrame = 1;
      if (this.skipTimer) {
        clearInterval(this.skipTimer);
      }
      this.skipCount = 5;
    },
    // 5s后跳转到分析结果页
    skipToResult() {
      this.skipTimer = setInterval(() => {
        this.skipCount -= 1;
        if (this.skipCount == 0) {
          this.checkResult();
        }
      }, 1000);
    },
    // 切换头像
    changePhoto() {
      if (this.photoIndex == 2) {
        this.photoIndex = 0;
      } else {
        this.photoIndex = this.photoIndex + 1;
      }
      this.logger.sum("最强蜗牛_愚人节_工作照切换");
      this.picture = this.homePhoto[this.photoIndex].url;
      this.setAccountInfoFun();
    },
    incrementTo100() {
      const target = 100;
      const duration = 2700; // 持续时间1秒
      const stepTime = duration / target; // 每一步的时间间隔
      const that = this;
      const intervalId = setInterval(() => {
        that.count += 1;
        if (that.count >= target) {
          clearInterval(intervalId); // 当达到100时停止计时器
        }
      }, stepTime);
    },
    // 页面滚动
    scrollToTop() {
      document.getElementsByClassName(
        "snail_aprilfoolsday_layout"
      )[0].scrollTop = 0;
    },
    itemClass(item, index) {
      let className = "";
      className =
        "itemClass item" +
        (item.rarity ? item.rarity : "") +
        " itemTip" +
        index;
      return className;
    },
    showTip(item, index) {
      if (!item.trait_name) return;
      // 如果点击的是相同按钮，直接隐藏
      if (this.activeIndex === index) {
        return (this.activeIndex = null);
      }
      // 取消之前的定时消失
      // clearTimeout(this.hideTimeout);
      // 设置当前激活的按钮
      this.activeIndex = index;
      // 2s 后自动隐藏
      // this.hideTimeout = setTimeout(() => {
      //   this.activeIndex = null;
      // }, 2000);
    },
    loginSuccess() {
      this.getUserInfo();
    },
    // 注销
    confirmLogout() {
      LogoutAPI().then((response) => {
        if (response.code === 200) {
          this.userInfo = {};
          this.activity = {};
          this.analysisAIDetail = {};
          this.isShowRed = 0;
          this.log_id = "";
          this.changeLoginPopup(true);
          // this.professional = "实习生"; // 职称
          // this.name = "实习生"; // 花名
          // this.department = "人力资源部";
          // this.problemsNum = 1; // 问题数量
          // this.currentProblem = 1; // 当前所在的问题
          // this.conversation1 = "去帮我倒一杯咖啡。"; // 对话1
          // this.conversation2 = "好的，老大。我的实习任务是什么"; // 对话2
          // this.conversation3 = "除了倒咖啡你还能干啥？"; // 对话3
          window.localStorage.removeItem("uuid");
          this.experienceInitFun();
        } else {
          this.onToast(response.message);
        }
      });
    },
    // 复制链接w
    onCopy(my_id) {
      this.logger.sum("最强蜗牛_愚人节_复制cdk");
      const clipboard = new Clipboard(my_id);
      clipboard.on("success", (e) => {
        console.log(clipboard, "success");
        this.onToast("复制成功");

        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        console.log(clipboard, "error");
        this.onToast("复制失败");
      });
    },
    qrcode(link) {
      generateQRCode(document.getElementById("qrcode"), {
        text: link,
        colorDark: "#b8957e",
        colorLight: "#f3eadb",
      });
      generateQRCode(document.getElementById("qrcode1"), {
        text: link,
        colorDark: "#b8957e",
        colorLight: "#f3eadb",
      });
    },
    // 分享图片设置
    generateShareImage() {
      if (!this.hasEvaluateResule) {
        return this.onToast("正在进行数据分析");
      }
      Indicator.open();
      this.logger.sum("最强蜗牛_愚人节_分析结果");
      generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          this.preventShow = false;
          this.shareImg = canvas.toDataURL("image/png"); // 可将 canvas 转为 base64 格式
          console.log("success: 图片生成成功");
          this.shareShow = true;
          Indicator.close();
        })
        .catch((err) => {
          this.preventShow = false;
          Indicator.close();
          console.log("err: 图片生成失败", err.message);
        });
    },
    // 海报页的前往新岗位
    goNewPosition() {
      this.logger.sum("最强蜗牛_愚人节_前往新岗位");
      this.showPage = 1;
      this.activeIndex = null;
      this.hasEvaluateResule = false;
      this.analysisAIDetail = {};
      this.getUserInfo();
      if (!this.userInfo.account) {
        this.changeLoginPopup(true);
      }
    },
    // 开启升值之路
    startGame() {
      this.isExperience = window.localStorage.getItem("isExperience");
      if (this.isExperience == "1" && !this.userInfo.account) {
        return (this.loginDialogShow = true);
      }
      this.logger.sum("最强蜗牛_愚人节_写日报");
      this.showPage = 2;
    },
    // 审批日报跳转
    approvalDaily() {
      if (!this.userInfo.account) {
        this.changeLoginPopup(true);
      } else {
        this.logger.sum("最强蜗牛_愚人节_审批日报");
        this.getListFun(1);
      }
    },
    // 账号登录
    accountLogin() {
      this.logger.sum("最强蜗牛_愚人节_账号登陆");
      this.loginDialogShow = false;
      this.changeLoginPopup(true);
    },
    // 再来一把(未登录)
    againNoLogin() {
      this.loginDialogShow = false;
      this.isExperience = window.localStorage.getItem("isExperience");
      if (this.isExperience == "1") {
        return this.changeLoginPopup(true);
      }
      this.logger.sum("最强蜗牛_愚人节_先开一把");
      this.showPage = 2;
    },
    // 获取用户信息
    getUserInfo() {
      const params = { uuid: window.localStorage.getItem("uuid") };
      onGetInitDataAPI(params).then((response) => {
        if (response.code === 200) {
          this.activity = response.data.activity;
          this.userInfo = response.data.user_info;
          this.isShowRed = response.data.activity.red;
          this.picture = response.data.user_info.game_picture;
          for (let i = 0; i < this.homePhoto.length; i++) {
            if (this.picture == this.homePhoto[i].url) {
              this.photoIndex = i;
              break;
            }
          }
          this.professional = response.data.user_info.game_rank;
          this.name = response.data.user_info.game_name;
          this.department = response.data.user_info.game_department;
          this.cdk = response.data.activity.cdk;
          this.areaName = response.data.activity.name;
          this.areaPhone = response.data.activity.user_phone;
          if (response.data.activity.address.includes("|")) {
            this.area = response.data.activity.address.split("|")[0];
            this.address = response.data.activity.address.split("|")[1];
          } else {
            this.area = response.data.activity.address;
            this.address = "";
          }
          if (response.data.activity.problem_array.problem.length > 0) {
            this.problemsNum = 2;
          } else {
            this.problemsNum = 1;
          }
          this.conversation1 =
            response.data.activity.problem_array.achievement[0];
          this.conversation2 =
            response.data.activity.problem_array.achievement[1];
          this.conversation3 =
            response.data.activity.problem_array.achievement[2];
        } else {
          if (response.code === 401) {
            return;
          }
          this.onToast(response.message);
        }
      });
    },
    // 上一题
    upProblem() {
      this.scrollToTop();
      this.currentProblem = 1;
      this.conversation1 = this.activity.problem_array.achievement[0];
      this.conversation2 = this.activity.problem_array.achievement[1];
      this.conversation3 = this.activity.problem_array.achievement[2];
    },
    // 下一题
    nextProblem() {
      this.scrollToTop();
      this.currentProblem = 2;
      this.conversation1 = this.activity.problem_array.problem[0];
      this.conversation2 = this.activity.problem_array.problem[1];
      this.conversation3 = this.activity.problem_array.problem[2];
    },
    // 免登录初始化
    experienceInitFun() {
      experienceInit().then((response) => {
        if (response.code == 200) {
          window.localStorage.setItem("uuid", response.data.uuid);
          this.getUserInfo();
        } else {
          this.onToast(response.message);
        }
      });
    },
    // 失焦请求修改花名接口
    inputFocusOut() {
      this.setAccountInfoFun();
    },
    // 设置花名和部门信息
    setAccountInfoFun() {
      const params = {
        game_name: this.name.trim(),
        game_picture: this.picture,
        uuid: window.localStorage.getItem("uuid"),
      };
      setAccountInfo(params).then((response) => {
        if (response.code === 200) {
          this.onToast("修改成功");
          this.getUserInfo();
        } else {
          this.onToast(response.message);
        }
      });
    },
    // 日报提交次数
    submitContextCountFun() {
      if (
        !this.questionText ||
        (!this.questionText1 && this.problemsNum == 2)
      ) {
        return this.onToast("请填写日报内容");
      }
      if (this.userInfo.account) {
        if (Number(this.activity.post_num) == 0) {
          this.submitContextFun();
          this.dialogShow1 = true;
          return;
        } else if (Number(this.activity.post_num) == 1) {
          return (this.dialogShow2 = true);
        } else if (Number(this.activity.post_num) == 2) {
          return (this.dialogShow3 = true);
        } else if (Number(this.activity.post_num) == 3) {
          return (this.dialogShow4 = true);
        } else if (Number(this.activity.post_num) == 4) {
          return (this.dialogShow5 = true);
        } else if (Number(this.activity.post_num) == 65) {
          return (this.dialogShow66 = true);
        }
      }
      this.submitContextFun();
    },
    // 提交日报
    submitContextFun() {
      if (!this.userInfo.account) {
        window.localStorage.setItem("isExperience", "1");
      }
      this.dialogShow1 = false;
      this.dialogShow2 = false;
      this.dialogShow3 = false;
      this.dialogShow4 = false;
      this.dialogShow5 = false;
      this.dialogShow66 = false;
      const params = {
        log_context: {
          achievement: this.questionText.trim(),
          problem: this.questionText1.trim(),
        },
        uuid: window.localStorage.getItem("uuid"),
      };
      submitContext(params).then((response) => {
        if (response.code === 200) {
          this.logger.sum("最强蜗牛_愚人节_提交日报");
          this.roleNum = Math.floor(Math.random() * 37) + 1;
          this.scrollToTop();
          this.questionText = "";
          this.questionText1 = "";
          this.log_id = response.data.log_id;
          this.cdk = response.data.cdk;
          if (this.activity.post_num != 0) {
            this.aniShow = true;
            this.startAnimation();
            this.analysisAIFun(this.log_id);
          }
          if (!this.userInfo.account) {
            this.aniShow = true;
            this.startAnimation();
            this.analysisAIFun(this.log_id);
          }
        } else {
          this.onToast(response.message);
        }
      });
    },
    // 第一次提交日报弹窗按钮
    dialog1Submit() {
      this.dialogShow1 = false;
      this.aniShow = true;
      this.startAnimation();
      this.analysisAIFun(this.log_id);
    },
    // 所有人日报触底加载
    handleScroll(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if (
        scrollTop + clientHeight >= scrollHeight - 50 &&
        this.showPage == 5 &&
        !this.isLoading
      ) {
        // 距离底部 10px 触发
        this.getListFun(this.pageNo + 1);
      }
    },
    // 切换日志列表筛选
    changeListType(type) {
      this.logger.sum(
        "最强蜗牛_愚人节_" + (type == 1 ? "我的日报" : "公司日报")
      );
      this.listType = type;
      this.getListFun(1);
    },
    // 获取日报列表
    getListFun(page) {
      this.pageNo = page;
      if (!this.userInfo.account) {
        return this.changeLoginPopup(true);
      }
      if (this.pageNo > this.totalPage || this.isLoading) {
        return;
      }
      if (page == 1) {
        this.rankList = [];
      }
      this.isLoading = true;
      const params = {
        type: 2,
        page: this.pageNo,
        is_my: this.listType == 2 ? "" : 1,
      };
      getList(params)
        .then((response) => {
          if (response.code === 200) {
            this.totalPage = response.data.last_page;
            this.rankList.push(...response.data.data);
            this.showPage = 5;
          } else {
            this.onToast(response.message);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // 日报点赞or取消or读取
    likeApiFun(item, type) {
      const params = {
        log_id: item.id, // 日报id
        type: item.like_status ? 2 : 1, // 1点赞 2踩
      };
      likeApi(params).then((response) => {
        if (response.code == 200) {
          if (type == 1) {
            // type==1时,是在排行榜点赞
            this.rankList.forEach((rankItem) => {
              if (rankItem.id == item.id) {
                rankItem.like_status = !item.like_status;
                rankItem.like_num = rankItem.like_status
                  ? rankItem.like_num + 1
                  : rankItem.like_num - 1;
                if (rankItem.like_status) {
                  rankItem.like_name.push({
                    game_name: this.userInfo.game_name,
                  });
                } else {
                  rankItem.like_name = rankItem.like_name.filter(
                    (likeItem) => likeItem.game_name != this.userInfo.game_name
                  );
                }
              }
            });
          } else {
            this.logDetailFun(item.id);
          }
        } else {
          this.onToast(response.message);
        }
      });
    },
    // 日报列表头像class
    avatarClassFun(item) {
      let className = "";
      for (let i = 0; i < this.homePhoto.length; i++) {
        if (item.game_picture == this.homePhoto[i].url) {
          className = `photo${i + 1}`;
        }
      }
      return className;
    },
    // 提取数组里面的名字并且拼起来用顿号隔开
    extractName(arr) {
      let nameArr = "";
      if (arr.length > 0) {
        nameArr = arr.map((item) => item.game_name).join("、");
        return nameArr;
      }
    },
    showLog() {
      if (!this.userInfo.account) {
        return this.changeLoginPopup(true);
      }
      this.logger.sum("最强蜗牛_愚人节_报告记录");
      this.logListFun();
    },
    // 评论触底加载
    logScroll(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if (
        scrollTop + clientHeight >= scrollHeight - 50 &&
        this.logShow &&
        !this.isLogLoading
      ) {
        // 距离底部 10px 触发
        this.logListFun(this.logPageNo + 1);
      }
    },
    // 个人日志记录
    logListFun(page) {
      this.logPageNo = page ? page : 1;
      if (this.logPageNo > this.logTotalPage || this.isLogLoading) {
        return;
      }
      if (this.logPageNo == 1) {
        this.logLists = [];
      }
      this.isLogLoading = true;
      const params = { page: this.logPageNo };
      logList(params)
        .then((response) => {
          if (response.code == 200) {
            this.logTotalPage = response.data.last_page;
            this.logLists.push(...response.data.data);
            if (this.logLists.length > 0) {
              this.logShow = true;
            } else {
              this.noLogShow = true;
            }
          } else {
            this.onToast(response.message);
          }
        })
        .finally(() => {
          this.isLogLoading = false;
        });
    },
    // 返回日报上一级
    gobackList() {
      if (this.dailyType == 1) {
        this.showPage = 1;
        this.logShow = true;
      } else {
        this.showPage = 5;
      }
    },
    gotoLogDetail(item, type) {
      if (this.antiShake) {
        return;
      }
      if (!type && item.individual_analysis == 1) {
        this.logger.sum("最强蜗牛_愚人节_详情切换上下篇");
        this.antiShake = true;
        setTimeout(() => {
          this.antiShake = false;
        }, 300);
      }
      this.dailyType = type ? type : this.dailyType;
      if (!item.individual_analysis && this.dailyType != 2 && type) {
        return;
      }
      this.log_id = item.id;
      this.logDetailFun(item.id);
      this.messageListFun(item.id);
    },
    // 日志详情
    logDetailFun(id) {
      const params = {
        id: id, // 日报id
      };
      logDetail(params).then((response) => {
        if (response.code == 200) {
          this.logShow = false;
          this.showPage = 6;
          this.logDetailData = response.data;
        } else {
          this.onToast(response.message);
        }
      });
    },
    sendComment() {
      if (!this.commentContent) {
        return this.onToast("请填写评论内容");
      }
      this.leaveWordFun();
    },
    // 日报留言
    leaveWordFun() {
      const params = {
        log_id: this.log_id, // 日报id
        user_content: this.commentContent, // 评论内容
      };
      leaveWord(params).then((response) => {
        if (response.code == 200) {
          this.commentContent = "";
          this.onToast("评论成功");
          this.isComment = true;
          this.messageListFun(this.log_id);
        } else {
          this.onToast(response.message);
        }
      });
    },
    // 评论触底加载
    commentScroll(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if (
        scrollTop + clientHeight >= scrollHeight - 50 &&
        this.showPage == 6 &&
        !this.isMessageLoading
      ) {
        // 距离底部 10px 触发
        this.messageListFun(this.log_id, this.messagePageNo + 1);
      }
    },
    // 日报留言列表
    messageListFun(id, page) {
      this.messagePageNo = page ? page : 1;
      if (this.messagePageNo > this.messageTotalPage || this.isMessageLoading) {
        return;
      }
      if (this.messagePageNo == 1) {
        this.messageLists = [];
      }
      this.isMessageLoading = true;
      const params = {
        log_id: id, // 日报id
        page: this.messagePageNo,
      };
      messageList(params)
        .then((response) => {
          if (response.code == 200) {
            this.messageTotalPage = response.data.last_page;
            if (this.isComment) {
              this.logDetailData.current_list.comment_count =
                response.data.total;
              this.isComment = false;
            }
            this.messageLists.push(...response.data.data);
          } else {
            this.onToast(response.message);
          }
        })
        .finally(() => {
          this.isMessageLoading = false;
        });
    },
    // 打开规则弹窗
    openRule() {
      this.rulesDialogShow = true;
      this.logger.sum("最强蜗牛_愚人节_活动规则");
    },
    // 打开我的奖励
    showAward() {
      if (!this.userInfo.account) {
        this.changeLoginPopup(true);
      } else {
        this.logger.sum("最强蜗牛_愚人节_我的奖励");
        this.awardRedFun();
        if (this.activity.is_admin_like != 0) {
          return (this.awardDialogShow = true);
        } else if (this.activity.cdk) {
          return (this.awardDialogShow1 = true);
        }
        this.noAwardShow = true;
      }
    },
    // 我的奖励红点
    awardRedFun() {
      awardRed().then((response) => {
        if (response.code == 200) {
          this.getUserInfo();
        } else {
          this.onToast(response.message);
        }
      });
    },
    // 中奖信息填写
    addressApiFun() {
      if (!this.areaName) {
        return this.onToast("请填写姓名");
      }
      if (!this.areaPhone) {
        return this.onToast("请填写手机号");
      }
      if (!/^1[3456789]\d{9}$/.test(this.areaPhone)) {
        return this.onToast("请输入正确的手机号");
      }
      if (!this.area) {
        return this.onToast("请填写地区");
      }
      if (!this.address) {
        return this.onToast("请填写详细地址");
      }
      const params = {
        name: this.areaName, // 姓名
        user_phone: this.areaPhone, // 手机号
        address: this.area + "|" + this.address, // 地址
      };
      addressApi(params).then((response) => {
        if (response.code == 200) {
          this.areaDialogShow = false;
          this.onToast("提交成功");
        } else {
          this.getUserInfo();
          this.onToast(response.message);
        }
      });
    },
    // 从报告记录进入海报
    goPoster(item) {
      if (!item.individual_analysis) {
        return;
      }
      const params = {
        log_id: item.id, // 日报id
        uuid: window.localStorage.getItem("uuid"),
      };
      analysisAI(params).then((response) => {
        if (response.code === 200) {
          this.logger.sum("最强蜗牛_愚人节_分析日报");
          this.analysisAIDetail = response.data.result;
          const trimArr = [];
          const trimObj = { desc: "", rarity: "", trait_name: "" };
          if (this.analysisAIDetail.trait.length != 9) {
            for (let i = 0; i < 9 - this.analysisAIDetail.trait.length; i++) {
              trimArr.push(trimObj);
            }
            this.analysisAIDetail.trait =
              this.analysisAIDetail.trait.concat(trimArr);
          }
          this.salutation = response.data.result.game_rank;
          this.echartsInit(response.data.result.six_dimensions);
          this.logShow = false;
          this.showPage = 4;
        } else {
          this.onToast(response.message);
        }
      });
      this.evaluateAIFun(item.id);
    },
    // AI分析（先拿六维图）
    analysisAIFun(id) {
      const params = {
        log_id: id, // 日报id
        uuid: window.localStorage.getItem("uuid"),
      };
      analysisAI(params).then((response) => {
        if (response.code === 200) {
          this.logger.sum("最强蜗牛_愚人节_分析日报");
          clearTimeout(this.analysisAITimer);
          this.analysisAIDetail = response.data.result;
          const trimArr = [];
          const trimObj = { desc: "", rarity: "", trait_name: "" };
          if (this.analysisAIDetail.trait.length != 9) {
            for (let i = 0; i < 9 - this.analysisAIDetail.trait.length; i++) {
              trimArr.push(trimObj);
            }
            this.analysisAIDetail.trait =
              this.analysisAIDetail.trait.concat(trimArr);
          }
          this.salutation = response.data.result.game_rank;
          this.echartsInit(response.data.result.six_dimensions);
          this.evaluateAIFun(id);
          // if (this.currentFrame == 200) {
          //   this.currentFrame = 201;
          // }
          // this.startAnimation();
        } else {
          this.analysisAITimer = setTimeout(() => {
            this.analysisAIFun(this.log_id);
          }, 5000);
        }
      });
    },
    // 六维图生成
    echartsInit(six_dimensions) {
      const echarts = window.echarts || echarts;
      const chartDom = document.getElementById("six-dimensions");
      const chartDomSummarize = document.getElementById("six-dimensions1");
      const myChart = echarts.init(chartDom);
      const myChartSummarize = echarts.init(chartDomSummarize);
      const option = {
        color: ["#96cce2"],
        radar: {
          splitNumber: 1,
          indicator: [
            { name: "", max: 200 },
            { name: "", max: 200 },
            { name: "", max: 200 },
            { name: "", max: 200 },
            { name: "", max: 200 },
            { name: "", max: 200 },
          ],
          textStyle: {
            color: "#77716a",
            fontWeight: "bold",
            fontSize: 30,
            fontFamily: "snail",
          },
          axisLine: {
            lineStyle: {
              color: "#BDBDBD",
              width: 1.1,
            },
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "#828282",
              width: 1.1,
            },
            show: false,
          },
          splitArea: {
            areaStyle: {
              color: "transparent",
            },
          },
          center: ["50%", "50%"],
          radius: "100%",
        },
        series: [
          {
            name: "ability",
            type: "radar",
            symbol: "none",
            data: [
              {
                value: [
                  six_dimensions.strength,
                  six_dimensions.luck,
                  six_dimensions.intelligence,
                  six_dimensions.constitution,
                  six_dimensions.charisma,
                  six_dimensions.dexterity,
                ],
                name: "ability-radar",
                areaStyle: {
                  color: "#7ec5ff",
                },
              },
            ],
          },
        ],
      };
      myChart.setOption(option);
      myChartSummarize.setOption(option);
    },
    // 结果分析（拿后续结果）
    evaluateAIFun(id) {
      const params = {
        log_id: id ? id : this.log_id, // 日报id
        uuid: window.localStorage.getItem("uuid"),
      };
      evaluateAI(params).then((response) => {
        if (response.code === 200) {
          clearTimeout(this.evaluateAITimer);
          this.hasEvaluateResule = true;
          this.analysisAIDetail.assessment = response.data.result.assessment;
          this.analysisAIDetail.evaluate_results =
            response.data.result.evaluate_results;
          this.analysisAIDetail.occupation = response.data.result.occupation;
          this.analysisAIDetail.saying = response.data.result.saying;
          this.analysisAIDetail.surpass = response.data.result.surpass;
          this.analysisAIDetail.value = response.data.result.value;
        } else {
          this.evaluateAITimer = setTimeout(() => {
            this.evaluateAIFun(id);
          }, 5000);
        }
      });
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: "toasts",
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // 微信分享
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/snail/aprilfoolsday/enter${getRandomString()}`,
        title: "正经人都写日报",
        imgUrl:
          "https://download4.qcplay.com/qcgame-api/eRmfoZmAEsdaQ8MeAUeeLKCz3V2TsTiGXuydK6IH.jpeg",
        desc: "从职场卡拉米到呼风唤雨大老板，只在你的一念之间，快来看看你在职场中的定位吧！",
      });
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
    ]),
    ...mapActions(["onInitDataCallback", "setShare"]),
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/aprilfoolsday/index/index.vue